import React, { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "./actionFeedback.css";
import TooLow from "../../../assets/images/too-low.png";
import Sad from "../../../assets/images/sad.png";
import Average from "../../../assets/images/avrage.png";
import Happy from "../../../assets/images/happy.png";
import Excelent from "../../../assets/images/excelent.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { feedbackSchema } from "../../../validation/validationSchema";
import { createFeedback, getFavorite } from "../../../redux/feedback/action";
import { helperFunction } from "../../../utils/helperFunctions";
import { Image, Container, Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import CountUp from "react-countup";
import { formatDate } from "../../../utils/formatDate";
import { useTranslation } from "react-i18next";

const ActionFeedback = ({ updatedAt, pageViewCount, loader }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const userId = helperFunction.getUserInfo();
  const shareUrl = window.location.href;

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(feedbackSchema),
  });

  useEffect(() => {
    if (userId) {
      const payload = { userId, pageUrl: shareUrl };
      dispatch(getFavorite(payload));
    }
  }, []);
  const handleEmojiClick = (value) => {
    setValue("rating", value);
    setShowForm(true);
  };

  const handleBackClick = () => {
    setShowForm(false);
  };

  const onFeedbackSubmit = (data) => {
    if (!userId) {
      toast.error(t("actionFeedback.loginRequired"));
      return;
    }

    const paylaod = {
      ...data,
      userId: userId,
      pageUrl: shareUrl,
    };
    dispatch(createFeedback(paylaod));
    reset();
    setShowForm(false);
  };

  return (
    <section className="action-feedback position-relative py-3">
      <Container>
        <Row
          className="justify-content-between align-items-center gy-3"
          data-aos="fade-up"
        >
          <Col xl={6} lg={5}>
            <div className="stats-section d-flex flex-lg-column flex-row justify-content-lg-star justify-content-between gap-lg-0 flex-wrap">
              <div className="stat-item d-flex align-items-center gap-3 mb-lg-0">
                <h6 className="stat-label fw-normal mb-0">
                  {t("actionFeedback.numberOfVisitors")}:
                </h6>
                <div className="stat-value me-3">
                  {loader ? (
                    <Skeleton width={50} height={40} />
                  ) : (
                    <CountUp start={0} end={pageViewCount} duration={2} />
                  )}
                </div>
              </div>
              <div className="stat-item d-flex align-items-center gap-3 mb-lg-0">
                <h6 className="stat-label fw-normal mb-0">
                  {t("actionFeedback.pageLastUpdated")}:
                </h6>
                <div className="stat-value">
                  {loader ? (
                    <Skeleton width={50} height={40} />
                  ) : (
                    formatDate(updatedAt)
                  )}
                </div>
              </div>
            </div>
          </Col>
          <Col xl={6} lg={7}>
            {!showForm ? (
              <div className="d-flex flex-wrap align-items-center justify-content-lg-end justify-content-start gap-3">
                <h5 className="d-block mb-0">
                  {t("actionFeedback.contentFeedback")}
                </h5>
                <div className="feedback-emojis">
                  {[1, 2, 3, 4, 5]?.map((value) => (
                    <div
                      key={value}
                      className="emoji"
                      onClick={() => handleEmojiClick(value)}
                      role="button"
                    >
                      <Image
                        src={
                          value === 1
                            ? TooLow
                            : value === 2
                              ? Sad
                              : value === 3
                                ? Average
                                : value === 4
                                  ? Happy
                                  : Excelent
                        }
                        alt={`Rating ${value}`}
                        fluid
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <form
                className="tell-us-form"
                onSubmit={handleSubmit(onFeedbackSubmit)}
              >
                <div className="form-content-wrapper">
                  <div className="d-flex flex-column mb-4">
                    <textarea
                      placeholder={t("actionFeedback.feedbackPlaceholder")}
                      {...register("feedback")}
                    ></textarea>
                    {errors.feedback && (
                      <p className="error-message mb-0">
                        {errors.feedback.message}
                      </p>
                    )}
                  </div>
                  <div className="back-submit-btns d-flex justify-content-between align-items-center">
                    <span onClick={handleBackClick}>
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </span>
                    <button type="submit" className="btn btn-sm btn-solid-blue">
                      {t("Submit")}
                      <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ActionFeedback;
